Garnish.$doc.ready(function () {

    // TODO: Comment out before production release
    // console.log('IN DEVELOPMENT') 

    // Update hovers on mobiles to clicks
    // let event = ('ontouchstart' in window) ? 'click' : 'mouseenter mouseleave'
    // console.log('event: ', event)

    // Mobile Menu
    window.mobileMenu = new SP.MobileNavigation('.main-nav-wrapper')

    window.mainNavigation = new SP.MainNavigation(document.getElementById('main-navigation-content'))

    // Mobile Collection Filters & Sort
    let mobileFilterSort = new SP.MobileFilterSort()

    // Global UI functions
    // assign to global window object
    window.UI = new SP.UI()

    // Notification Bar
    let notificationBars = $('[data-notification]')
    if (notificationBars) {
        $.each(notificationBars, function (index, el) {
            new SP.NotificationBar(el)
        })
    }

    // Product tiles for homepage featured products
    if ($('.template-index').length > 0 || $('.page-takibi-fire-grill-getting-started').length > 0 || $('.page-iron-grill-table-getting-started').length > 0 || $('.template-search').length > 0) {
        let productTiles = $('.product-tile')
        if (productTiles.length > 0) {
            $.each(productTiles, function (index, el) {
                new SP.ProductTile(el)
            })
        }
    }

    // Product Callouts
    let productCallouts = $('[data-product-callout]')
    if (productCallouts) {
        $.each(productCallouts, function (index, el) {
            new SP.ProductCallout(el)
        })
    }

    // Content Callouts
    let contentCallouts = $('[data-content-callout]')
    if (contentCallouts) {
        $.each(contentCallouts, function (index, el) {
            new SP.PageCallout(el)
        })
    }

    // Search Autocomplete
    // let searchAutocomplete = new SP.SearchAutocomplete()

    // Footer Accordions
    let footerAccordions = $('[data-accordion]')
    if (footerAccordions) {
        $.each(footerAccordions, function (index, el) {
            new SP.Accordion(el)
        })
    }

    // Category Navigation
    let categoryNavigation = $('.category-nav')
    if (categoryNavigation.length > 0) {
        new SP.CategoryNavigation(categoryNavigation)
    }

    // Collection Sort By
    let collectionSortBy = $('#sort-by')
    if (collectionSortBy.length > 0) {
        new SP.CollectionSortBy(collectionSortBy)
    }

    // Mobile touch events
    // if ($('.touchevents').length > 0) {
    //     console.log('this is mobile device with touch events')
    // }

    /* Prevent default if menu links are "#". */
    $('a').each(function () {
        let nav = $(this)
        if (nav.length > 0) {
            if (nav.attr('href') === '#') {
                //console.log(nav);
                $(this).on('click', function (e) {
                    e.preventDefault()
                })
            }
        }
    })

    // Browser detection
    $.browserDetection(true)

    // Checkout Page
    if ($('[data-has-customized]').length > 0) {
        let $lineItems = $('.lineItem')

        $.each($lineItems, function(i, el) {
            let $lineItem = $(el)
            new LineItemTransform($lineItem)
        })

        // Add final notice message
        $('.order-summary__section--product-list').after(`<div class="final-sale-message" style="margin-bottom: 25px;"><p>${SP.finalSaleMessage}</p></div>`)
    }
})

// let pplr_custom_form_add = function() {
//     console.log('hi')
// }


LineItemTransform = Garnish.Base.extend({
    id: null,
    productId: null,
    variantId: null,
    productType: null,
    $lineItem: null,

    $matchingElement: null,
    previewImageUrl: null,
    fee: null,

    init($lineItem) {
        this.$lineItem = $lineItem;
        this.id = this.$lineItem.data('id')
        this.productId = this.$lineItem.data('product-id')
        this.variantId = this.$lineItem.data('variant-id')
        this.productType = this.$lineItem.data('product-type')
        this.fee = this.$lineItem.data('fee-nice')
        this.previewImageUrl = this.$lineItem.data('preview-image-url')

        console.log(this.previewImageUrl)

        this.$matchingElement = $(`a[href="${this.previewImageUrl}"]`).closest('.product')

        if (this.$matchingElement) {
            let engravingMarkup = this.$matchingElement.find('.product__description__property')
            console.log(engravingMarkup)
            this.$matchingElement.find('.product__price').append(`<span style="color: gray; font-size: 12px; display: block;">+ ${this.fee}</span>`)
        }
    },

})
